import Layout from "../../layouts/layout";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { DatePicker } from "react-advance-jalaali-datepicker";
import { useEffect, useState } from "react";
import MainPageLayout from "../../components/main-page-layout/mainPageLayout";
import { useRequestProcessor } from "../../api/requestProcessor";
import { useNavigate, useParams } from "react-router-dom";
import { getSingleTemplate, storeSingleTemplates, updateSingleTemplates } from "../../api/kavenegar";
import Loading from "../../components/loading/loading";

const EditTemplate = () => {

    const [approved, setapproved] = useState(false)


    const { Query, Mutate } = useRequestProcessor();
    const navigate = useNavigate()
    const { kavenegar_id } = useParams()

    const { data, isLoading, isError } = Query(
        ['getSingleTemplate',],
        () => getSingleTemplate(kavenegar_id),
    );

    const { mutate } = Mutate(
        "updateSingleTemplate",
        updateSingleTemplates,
        {
            onSuccess: (data) => {
                toast.success(data.message)
                toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
                    autoClose: 2500,
                    pauseOnHover: false
                })
                setTimeout(() => { navigate("/admin/kavenegar") }, 3000)
            }
            ,
            onError : (data) => {
                toast.error(data.response.data.message)
            }
        }

    )


    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        setapproved(data?.data?.status === "approved")
        reset(data?.data)
    }, [data])


    async function onHookFormhandler(data) {
        const newData = { id :kavenegar_id ,data : {
            title:data?.title,
            name:data?.name,
            message:data?.message,
            status:data?.status,
        }}

        mutate(newData)
    }



    return (
        <Layout title="تصحیح قالب">
            <MainPageLayout title={"تصحیح قالب"} >
                {!isLoading && <form onSubmit={handleSubmit((data) => onHookFormhandler(data))} className='flex flex-col'>
                    {/* <h1 className="text-[1.5rem]">ایجاد کاربر جدید</h1> */}
                    <div className="flex wsm:flex-col">
                        <div className='flex-col my-4 !w-full'>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.title && "text-red-500"}`}>عنوان :</p>
                                <input type="text" {...register("title", { required: true })} className='form-input !w-full' placeholder='عنوان' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.name && "text-red-500"}`}>عنوان کاوه نگار (به انگلیسی) :</p>
                                <input type="text" {...register("name", { required: true })} className='form-input !w-full' placeholder='به انگلیسی وارد کنید ' />
                            </div>
                            <div className="mx-10 items-center flex wsm:!mx-0 mt-2">
                                <p>تایید شده</p>
                                <label class="relative inline-flex  cursor-pointer mx-2">
                                    <input type="checkbox" value={approved} onChange={(e) => setapproved(prev => !prev)} class="sr-only peer" />
                                    <div class={`w-11 h-6  rounded-full peer ${approved ? "bg-sky-300" : "bg-gray-200"}  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                </label>
                                <p>تایید نشده</p>
                            </div>
                        </div>
                        <div className="flex-col my-4 !w-full mr-2">
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.message && "text-red-500"}`}>پیغام :</p>
                                <textarea type="text" rows={5} {...register("message", { required: true })} className={`form-input !w-full`} placeholder='پیغام خود را  به همراه توکن وارد کنید' />
                            </div>
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>}
                {
                    isLoading && <Loading /> 
                }
            </MainPageLayout>
        </Layout>
    )
}

export default EditTemplate